import React from 'react';
import { sortDescDataByLabel, sortDescDataByLabelRanges } from '../../../../utils/harvestData';
import { ApplicationStats, LabelColor, YieldRegionReport } from '../../../../types';
import { ApplicationStatsLabel } from '../RegionReportItemsRow/ApplicationStatsLabel';
import { ColorStatsLabel } from '../RegionReportItemsRow/ColorStatsLabel';
import { YieldReportStatsLabel } from '../RegionReportItemsRow/YieldReportStatsLabel';

export type RegionReportItemsProps = {
  allowHover?: boolean;
  colors?: LabelColor;
  data?: ApplicationStats[] | YieldRegionReport[];
  dataTestId: string;
  locale: string;
  onClick: (item: YieldRegionReport) => void;
  showIcon: boolean;
  index: number;
  displayRanges: boolean;
  cropCode: string;
};

function isApplicationStats(item: ApplicationStats) {
  return Object.prototype.hasOwnProperty.call(item, 'dateApplied');
}

type ReportingItems =  (ApplicationStats | YieldRegionReport)[];

export const RegionReportItems = ({
  allowHover,
  colors = [],
  data = [],
  dataTestId,
  index,
  locale,
  onClick,
  showIcon,
  displayRanges,
  cropCode
}: RegionReportItemsProps) => {
  const unsortedData = (data ?? []) as ReportingItems;

  let sortedData: ReportingItems;
  if (displayRanges) {
    sortedData = unsortedData.sort(sortDescDataByLabelRanges);
  } else {
    sortedData = unsortedData.sort(sortDescDataByLabel);
  }
  
  return (
    <>
      {sortedData.map((item) => {
        if (isApplicationStats(item as ApplicationStats)) {
          return <ApplicationStatsLabel
            allowHover={allowHover}
            dataTestId={dataTestId}
            index={index}
            item={item as ApplicationStats}
            locale={locale}
            showIcon={showIcon}
            key={`application-stats-${dataTestId}-${item.label}`}
            cropCode={cropCode}
          />
        }
        if (colors?.length > 0) {
          return <ColorStatsLabel
            allowHover={allowHover}
            colors={colors}
            dataTestId={dataTestId}
            index={index}
            item={item as YieldRegionReport}
            onClick={onClick}
            showIcon={showIcon}
            key={`color-stats-${dataTestId}-${item.label}`}
            cropCode={cropCode}
          />
        }

        return <YieldReportStatsLabel
          allowHover={allowHover}
          dataTestId={dataTestId}
          index={index}
          item={item as YieldRegionReport}
          onClick={onClick}
          showIcon={showIcon}
          key={`yield-stats-${dataTestId}-${item.label}`}
          cropCode={cropCode}
        />
      })}
    </>
  );
};